import { useMemo } from 'react';
import memoize from 'lodash/memoize';

/**
 * Creates a function with memoized results, that won't get
 * it's cache cleared on render of component.
 *
 * @param factory Function to be memoized
 */
function useMemoize(factory) {
  return useMemo(function () {
    return memoize(factory);
  }, [factory]);
}

export default useMemoize;
